import { useState } from 'react'

import { Card } from '@/design'

type CopyState = 'idle' | 'copied' | 'failed'

/**
 * The address a tenant adds as Viewer on their GA4 property. It is TmT's
 * service account for this environment; the key behind it never leaves the
 * server, so the email is all there is to show.
 */
export function ServiceAccountCard({ email }: { email: string }) {
  const [copy, setCopy] = useState<CopyState>('idle')

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email)
      setCopy('copied')
    } catch {
      setCopy('failed')
    }
  }

  return (
    <Card title="Step 1 — give Competition Insights read access" subtitle="Read-only access to your traffic aggregates. No personal data is imported.">
      <p className="ci-integration__note">
        In Google Analytics open <strong>Admin › Property access management</strong>, add this address as a{' '}
        <strong>Viewer</strong> on your GA4 property, then connect the property below.
      </p>
      <p className="ci-integration__email">
        <code aria-label="Service account email">{email}</code>{' '}
        <button type="button" className="ci-button" data-variant="ghost" onClick={() => void copyEmail()}>
          Copy email
        </button>
      </p>
      {copy === 'copied' ? (
        <p role="status" className="ci-integration__ok">
          Copied.
        </p>
      ) : null}
      {copy === 'failed' ? (
        <p role="alert" className="ci-integration__error">
          Your browser would not copy it. Select the address above and copy it by hand.
        </p>
      ) : null}
    </Card>
  )
}
